<template>
  <v-container fluid>
    <v-slide-group v-model="model" class="pa-4" center-active show-arrows>
      <v-slide-item
        v-for="( item, index ) in BlogPosts"
        :key="index"
        v-slot:default="{ active, toggle }"
      >
        <uBlogPost :ClassAd="'ma-4'" @click="toggle" v-bind:value="item" :active="active" :key="index" />
      </v-slide-item>
    </v-slide-group>

<v-card
    elevation="24"
    max-width="600"
    class="mx-auto"
  >

   <v-carousel cycle height="500">
    <v-carousel-item
      v-for="(item,i) in BlogPosts"
      :key="i"
      :src="item.Image"      
    >
    <uBlogPost2 :ClassAd="'ma-4'" v-bind:value="item" :active="active" :key="index" />
    </v-carousel-item>
  </v-carousel>

</v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import store from "../store";

import uBlogPost from "./../components/BlogPost";
import uBlogPost2 from "./../components/BlogPost2";

//var extBlogPosts = [];

//store.commit('addBlogPosts', );

window.extBlogPosts = [];

var impscr = document.createElement("script");
impscr.innerHTML =
  //  "window.extBlogPosts = [];" +
  "function getBlogPosts(json) {" +
  "  for (var i = 0; i < json.feed.entry.length; i++) {" +
  '    var postUrl = "";' +
  "    for (var j = 0; j < json.feed.entry[i].link.length; j++) {" +
  '      if (json.feed.entry[i].link[j].rel == "alternate") {' +
  "        postUrl = json.feed.entry[i].link[j].href;" +
  "        break;" +
  "      }" +
  "    }" +
  '    console.log("Posts", json.feed.entry[i]);' +
  "    window.extBlogPosts.push({" +
  //'    store.commit("addBlogPost", {',
  "      Title: json.feed.entry[i].title.$t," +
  "      Author: json.feed.entry[i].author[0].name.$t," +
  "      AuthorImg: 'https://' + json.feed.entry[i].author[0].gd$image.src," +
  '      Summary: json.feed.entry[i].summary.$t,' +
  "      Url: postUrl," +
  '      Image: json.feed.entry[i].media$thumbnail.url.replace("s72-c/", "s1600/")' +
  "    });" +
  "  }" +
  "}";
document.head.appendChild(impscr);

var imported = document.createElement("script");
imported.src =
  "https://blog.violentnoise.com.br/feeds/posts/summary?orderby=published&max-results=10&alt=json-in-script&callback=getBlogPosts";
document.head.appendChild(imported);

var interval = setInterval(finterval, 1000);

console.log("BlogPosts - Vue - Before componente", window.extBlogPosts);

function finterval() {
  if (window.extBlogPosts.length > 4) {
    store.commit("setBlogPosts", window.extBlogPosts);

    console.log("BlogPosts - Vue - Processou", window.extBlogPosts);

    clearInterval(interval);
  } else {
    console.log("BlogPosts - Vue - Processando", window.extBlogPosts);
  }
}

export default {
  components: { uBlogPost, uBlogPost2 },
  data() {
    return {
      model: null
    };
  },
  mounted() {
    console.log("BlogPosts - Vue - mounted", this.BlogPosts);
  },
  created() {},
  watch: {
    BlogPosts() {
      console.log("state.BlogPosts", this.BlogPosts);
    }
  },
  computed: mapState([
    // map this.count to store.state.count
    "BlogPosts"
  ]),
  methods: {}
};
</script>
